import { Link } from "react-router-dom";
import { useSettings } from "@/hooks/useSettings";

export function Footer() {
  const { settings } = useSettings();
  const copyright = (settings.footer_copyright || "").replace("{year}", new Date().getFullYear());
  return (
    <footer className="mt-auto border-t border-slate-200 bg-white" data-testid="site-footer">
      <div className="container-x flex flex-col gap-4 py-8 text-sm text-slate-500 sm:flex-row sm:items-center sm:justify-between">
        <p data-testid="footer-copyright">{copyright}</p>
        <nav className="flex flex-wrap gap-x-5 gap-y-2" aria-label="Footer">
          {(settings.footer_links || []).map((l) =>
            l.url?.startsWith("/") ? (
              <Link key={l.url + l.label} to={l.url} className="hover:text-slate-900" data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>{l.label}</Link>
            ) : (
              <a key={l.url + l.label} href={l.url} className="hover:text-slate-900" rel="noopener noreferrer" target="_blank">{l.label}</a>
            ),
          )}
          {(settings.social_links || []).map((l) => (
            <a key={l.url} href={l.url} className="hover:text-slate-900" rel="noopener noreferrer" target="_blank">{l.label}</a>
          ))}
        </nav>
      </div>
    </footer>
  );
}
